// Client-and-server-safe locale constants — kept separate from
// i18n/request.ts (which pulls in next/headers, server-only) so a client
// component like a language switcher can import this without breaking the
// client bundle.
export const LOCALES = ['en', 'es'] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = 'en';
export const LOCALE_COOKIE = 'GOONRU_LOCALE';

export const LOCALE_LABELS: Record<Locale, string> = {
  en: 'English',
  es: 'Español',
};

// English names, for instructing an LLM what language to reply in (see
// generateCompanionResponse in lib/llm-service.ts) — distinct from
// LOCALE_LABELS above, which uses each language's own native name for the
// UI switcher. An English-authored system prompt reads more reliably to a
// model with "Spanish" than "Español".
export const LOCALE_ENGLISH_NAMES: Record<Locale, string> = {
  en: 'English',
  es: 'Spanish',
};

// Set by the proxy (lib/supabase/proxy.ts, Accept-Language negotiation)
// when a visitor has no locale cookie yet. i18n/request.ts falls back to it
// so the very first page render already matches their browser language
// instead of flashing English before the cookie exists on their next request.
export const NEGOTIATED_LOCALE_HEADER = 'x-goonru-negotiated-locale';
